import ObjectMapper from "./ObjectMapper"

export default class ActionLogEntry {
    static FIELDS = [
        { name: 'remoteAddress', required: true, check: it => ObjectMapper.checkNonEmptyString(it) },
        { name: 'actionTime', required: true, check: it => ObjectMapper.checkNonEmptyString(it) },
        { name: 'userId', required: true },
        { name: 'zoneId', required: true },
        { name: 'actionType', required: true, check: it => ObjectMapper.checkNumber(it) },
        { name: 'actionDetails', required: true }
    ]

    constructor () {
        this.remoteAddress = ''
        this.actionTime = ''
        this.userId = -1
        this.zoneId = -1
        this.actionType = -1
        this.actionDetails = ''
    }

    static fromObject (o) {
        return ObjectMapper.map(o, 'ActionLogEntry', ActionLogEntry.FIELDS)
    }
}